import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./Routes";
import useTheme from "./hooks/useTheme";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "./utils/NavigationHelper";

const App = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  return (
    <>
      <AppRoutes />
    </>
  );
};

export default App;
